import { IDENTITY_CONFIG, IDENTITY_CONFIG_MODERN } from '../../authconst';
import { UserManager, WebStorageStateStore, Log } from 'oidc-client';
import { isModernApi } from '../../index';

export default class AuthService {
  UserManager;

  constructor() {
    Log.logger = console;
    Log.level = Log.DEBUG;
    console.log('the log');
    console.log(Log.level);
    Log.info('info debug ---- ');
    this.UserManager = new UserManager(
      isModernApi() ? { ...IDENTITY_CONFIG_MODERN } : { ...IDENTITY_CONFIG }
    );

    this.UserManager.events.addSilentRenewError(e => {
      console.log('silent renew error', e.message);
    });

    this.UserManager.events.addAccessTokenExpired(() => {
      console.log('token expired');
      this.logout();
      //this.signinRedirect();
    });
  }

  signinRedirectCallback = () => {
    console.log('signinRedirectCallback');

    this.UserManager.signinRedirectCallback()
      .then(res => {
        console.log('signinRedirectCallback res', res);
      })
      .catch(err => {
        console.log('signinRedirectCallback error');
        console.log(err);
      });
  };

  getUser = async () => {
    const user = await this.UserManager.getUser();
    if (!user) {
      console.log('get user signinRedirectCallback');
      return await this.UserManager.signinRedirect();
    }
    return user;
  };

  parseJwt = token => {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
  };

  signinRedirect = () => {
    console.log('sign in redirect');
    localStorage.setItem(
      'redirectUri',
      `${process.env.REACT_APP_HOST_URL}/signin-callback.html`
    );
    this.UserManager.signinRedirect({
      redirect_uri: `${process.env.REACT_APP_HOST_URL}/signin-callback.html`
    });
  };

  isAuthenticated = () => {
    const oidcStorage = JSON.parse(
      sessionStorage.getItem(
        isModernApi()
          ? `oidc.user:${IDENTITY_CONFIG_MODERN.authority}:${
              IDENTITY_CONFIG_MODERN.client_id
            }`
          : `oidc.user:${IDENTITY_CONFIG.authority}:${
              IDENTITY_CONFIG.client_id
            }`
      )
    );
    return !!oidcStorage && !!oidcStorage.access_token;
  };

  // signinSilent = () => {
  //   console.log('signinSilent');
  //   this.UserManager.signinSilent()
  //     .then(user => {
  //       console.log('signed in', user);
  //     })
  //     .catch(err => {
  //       console.log('err', err);
  //     });
  // };
  // signinSilentCallback = () => {
  //   this.UserManager.signinSilentCallback();
  // };

  createSigninRequest = () => {
    return this.UserManager.createSigninRequest();
  };

  logout = () => {
    this.UserManager.signoutRedirect({
      id_token_hint: localStorage.getItem('id_token')
    });
    this.UserManager.clearStaleState();
  };

  signoutRedirectCallback = () => {
    this.UserManager.signoutRedirectCallback().then(() => {
      localStorage.clear();
    });
    this.UserManager.clearStaleState();
  };
}
